var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { bindable } from "aurelia-framework";
import { LotteryKeyHelper } from "../../../services/modules/brand-client.service";
import { activationStrategy } from "aurelia-router";
var BaseQuickPlay = /** @class */ (function () {
    function BaseQuickPlay() {
        this.lotteries = [];
    }
    BaseQuickPlay.prototype.activate = function () {
    };
    BaseQuickPlay.prototype.determineActivationStrategy = function () {
        return activationStrategy.replace;
    };
    BaseQuickPlay.prototype.lotteriesChanged = function () {
        if (this.lotteries && this.lotteries[0]) {
            var quickPlay = this.lotteries[0];
            this.currentLottery = {
                key: LotteryKeyHelper.getKey(quickPlay.lotteryName),
                brandLotteryId: quickPlay.brandLotteryId,
                lotteryId: quickPlay.lotteryId
            };
        }
    };
    BaseQuickPlay.prototype.navigateToLottery = function (quickPlay) {
        var _this = this;
        this.currentLottery = null;
        setTimeout(function () {
            _this.currentLottery = {
                key: LotteryKeyHelper.getKey(quickPlay.lotteryName),
                brandLotteryId: quickPlay.brandLotteryId,
                lotteryId: quickPlay.lotteryId
            };
        });
    };
    __decorate([
        bindable,
        __metadata("design:type", Array)
    ], BaseQuickPlay.prototype, "lotteries", void 0);
    return BaseQuickPlay;
}());
export { BaseQuickPlay };
var QuickPlayNavigationModel = /** @class */ (function () {
    function QuickPlayNavigationModel() {
    }
    return QuickPlayNavigationModel;
}());
export { QuickPlayNavigationModel };
